import isMobileHeader from "../__utils/isMobileHeader";

const $ = jQuery.noConflict();
const header = $('.main-header');
const hideElements = $('.main-header__icons, .main-header__custom-nav');
const lastY = 0;
let stickyState = 0;

const STATE_STICKY = 1;
const STATE_NOSTICKY = 0;
const STICKY_CLASS = 'sticky';
const WHITE_BG_CLASS = 'main-header--w-bg';

/**
 * Add WHITE_BG_CLASS for header.
 *
 */
 const addAdditionalClassHeader = () => {
	header.addClass(WHITE_BG_CLASS);
}

/**
 * Listener for resize and fix elements visibility on breakpoint
 *
 */
const stickyResizeFix = () => {
	if ( isMobileHeader() ) {
		hideElements.show();
	} else {
		if ( stickyState === STATE_STICKY ) {
			hideElements.hide();
		}
	}
}

/**
 * Set sticky state for false.
 *
 */
const removeStickyClass = () => {
	if ( stickyState && !isMobileHeader() ) {
		hideElements.show();
	}
	stickyState = STATE_NOSTICKY;
	header.removeClass(STICKY_CLASS);
	header.removeClass(WHITE_BG_CLASS);
}

/**
 * Set sticky state for true.
 *
 */
const addStickyClass = () => {
	if ( !stickyState && !isMobileHeader() ) {
		hideElements.hide();
	}
	stickyState = STATE_STICKY;
	header.addClass(STICKY_CLASS);
}

/**
 * Exec code druing scroll.
 * Toggle sticky state.
 *
 */
const checkScroll = () => {
	if ( document.body.classList.contains('lock-scroll') ) {
		return;
	}

	const currentY = window.scrollY;

	if ( currentY === 0 ){
		removeStickyClass();
	}else if ( window.scrollY > lastY ) {
		addStickyClass();
	}
}

/**
 * Init methods.
 *
 */
const init = () => {
	checkScroll();
}

export {removeStickyClass, addStickyClass, stickyResizeFix, addAdditionalClassHeader};
export default init;